import React from "react";
import moment from "moment";
import logo from "../../../assets/images/asset-planet-background.png";
import incomeIcon from "../../../assets/images/Contributions-income.png";
import passiveIncomeIcon from "../../../assets/images/easy.png";
import activeIncomeIcon from "../../../assets/images/lift_weight.png";

export const IncomePDFReport = ({
  incomeList,
  incomeReport,
  chartImage,
  clientName,
}) => {
  const formatCurrency = (val) => {
    return (parseFloat(val) || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div
      id="income-report-pdf"
      style={{
        padding: "60px 30px",
        backgroundColor: "#fff",
        width: "950px",
        margin: "0 auto",
        fontFamily: "'Inter', sans-serif",
        color: "#000",
        boxSizing: "border-box",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
          borderBottom: "2px solid #eee",
          paddingBottom: "20px",
        }}
      >
        <img src={logo} alt="Logo" style={{ height: "50px", objectFit: "contain" }} />
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "14px", color: "#666", fontWeight: "600" }}>Report Generated</div>
          <div style={{ fontSize: "16px", fontWeight: "bold", color: "#1F3C88" }}>
            {moment().format("MMMM D, YYYY")}
          </div>
        </div>
      </div>

      <h1 style={{ fontSize: "32px", fontWeight: "800", marginBottom: "5px", color: "#1c1c1c", letterSpacing: "-1px" }}>
        Income Report
      </h1>
      <div style={{ fontSize: "16px", color: "#666", fontWeight: "600", marginBottom: "25px" }}>
        Client: <span style={{ color: "#1F3C88", fontWeight: "800" }}>{clientName || "N/A"}</span>
      </div>

      {/* Summary Tiles Section */}
      <div data-pdf-section style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px", marginBottom: "40px" }}>
        {/* Total Income Tile */}
        <div style={{ backgroundColor: "#f8faff", padding: "20px", borderRadius: "16px", border: "1px solid #e1e8f5", textAlign: "center" }}>
          <img src={incomeIcon} alt="Total Income" style={{ height: "40px", marginBottom: "10px" }} />
          <h3 style={{ fontSize: "14px", color: "#1F3C88", fontWeight: "700", margin: "0 0 10px 0" }}>Total Income</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <div>
               <span style={{fontSize: "12px", color: "#666"}}>Year to date: </span>
               <span style={{ fontSize: "18px", fontWeight: "800", color: "#1a2a52" }}>
                 ${formatCurrency(incomeReport && incomeReport.totalYearly)}
               </span>
            </div>
            <div>
               <span style={{fontSize: "12px", color: "#666"}}>This Month: </span>
               <span style={{ fontSize: "18px", fontWeight: "800", color: "#1a2a52" }}>
                 ${formatCurrency(incomeReport && incomeReport.totalMonthly)}
               </span>
            </div>
          </div>
        </div>

        {/* Active Income Tile */}
        <div style={{ backgroundColor: "#fff9f0", padding: "20px", borderRadius: "16px", border: "1px solid #fee2b3", textAlign: "center" }}>
          <img src={activeIncomeIcon} alt="Active Income" style={{ height: "40px", marginBottom: "10px" }} />
          <h3 style={{ fontSize: "14px", color: "#e67e22", fontWeight: "700", margin: "0 0 10px 0" }}>Active Income</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
             <div>
                <span style={{fontSize: "12px", color: "#666"}}>Year to date: </span>
                <span style={{ fontSize: "18px", fontWeight: "800", color: "#1a2a52" }}>
                  ${formatCurrency(incomeReport && incomeReport.yearlyActiveIncome)}
                </span>
             </div>
             <div>
                <span style={{fontSize: "12px", color: "#666"}}>This Month: </span>
                <span style={{ fontSize: "18px", fontWeight: "800", color: "#1a2a52" }}>
                  ${formatCurrency(incomeReport && incomeReport.monthlyActiveIncome)}
                </span>
             </div>
          </div>
        </div>

        {/* Passive Income Tile */}
        <div style={{ backgroundColor: "#f0fdf4", padding: "20px", borderRadius: "16px", border: "1px solid #dcfce7", textAlign: "center" }}>
          <img src={passiveIncomeIcon} alt="Passive Income" style={{ height: "40px", marginBottom: "10px" }} />
          <h3 style={{ fontSize: "14px", color: "#166534", fontWeight: "700", margin: "0 0 10px 0" }}>Passive Income</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
             <div>
                <span style={{fontSize: "12px", color: "#666"}}>Year to date: </span>
                <span style={{ fontSize: "18px", fontWeight: "800", color: "#1a2a52" }}>
                  ${formatCurrency(incomeReport && incomeReport.yearlyPassiveIncome)}
                </span>
             </div>
             <div>
                <span style={{fontSize: "12px", color: "#666"}}>This Month: </span>
                <span style={{ fontSize: "18px", fontWeight: "800", color: "#1a2a52" }}>
                  ${formatCurrency(incomeReport && incomeReport.monthlyPassiveIncome)}
                </span>
             </div>
          </div>
        </div>
      </div>

      {/* Chart Section */}
      <div data-pdf-section style={{ marginBottom: "50px" }}>
        <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px", color: "#1c1c1c", borderLeft: "5px solid #1F3C88", paddingLeft: "15px" }}>
          Income Trends
        </h2>
        <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "12px", border: "1px solid #f0f0f0", textAlign: "center", minHeight: "300px" }}>
          {chartImage ? (
            <img src={chartImage} alt="Income Chart" style={{ maxWidth: "100%", height: "auto" }} />
          ) : (
            <div style={{ color: "#ccc", paddingTop: "120px", fontStyle: "italic" }}>No chart data available for this period</div>
          )}
        </div>
      </div>

      {/* Income Table */}
      <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px", color: "#1c1c1c", borderLeft: "5px solid #2A3DA3", paddingLeft: "15px" }}>
        Income Sources Details
      </h2>
      <table data-pdf-section style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0", marginBottom: "50px", borderRadius: "12px", overflow: "hidden", border: "1px solid #E0E0E0" }}>
        <thead>
          <tr style={{ backgroundColor: "#2A3DA3", color: "#fff" }}>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>Income Name</th>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>Type</th>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>Frequency</th>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>Start Date</th>
            <th style={{ padding: "12px 14px", textAlign: "left", fontSize: "12px" }}>End Date</th>
            <th style={{ padding: "12px 14px", textAlign: "right", fontSize: "12px" }}>Monthly Gross</th>
          </tr>
        </thead>
        <tbody>
          {incomeList && incomeList.length > 0 ? (
            incomeList.map((item, index) => {
              return (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc" }}>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Income Name"] || item.income_name || "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Passive or Active"] || item.active_passive_val || "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Frequency of Pay Periods"] || item.frequency || "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Date Income Starts"] || item.income_start_date ? moment(item["Date Income Starts"] || item.income_start_date).format("MM/DD/YYYY") : "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px" }}>{item["Date Income Ends"] || item.income_end_date ? moment(item["Date Income Ends"] || item.income_end_date).format("MM/DD/YYYY") : "N/A"}</td>
                  <td style={{ padding: "12px 14px", borderTop: "1px solid #eee", fontSize: "12px", fontWeight: "bold", textAlign: "right" }}>${formatCurrency(item["Gross Monthly Wages"] || item.gross_monthly_wages)}</td>
                </tr>
              );
            })
          ) : (
            <tr><td colSpan="6" style={{ padding: "30px", textAlign: "center", color: "#999" }}>No income sources found</td></tr>
          )}
        </tbody>
      </table>

      {/* Footer */}
      <div
        data-pdf-section
        style={{
          fontSize: "11px",
          lineHeight: "1.6",
          color: "#666",
          marginTop: "40px",
          textAlign: "center",
          padding: "20px",
          borderTop: "1px solid #eee",
        }}
      >
        <strong>Confidential & Unaudited:</strong> This report is intended solely for the named recipient and is for informational purposes only. The data reflects information provided by the user and has not been audited by <strong>Asset Planet.</strong> Asset Planet makes no warranty regarding the data's accuracy or completeness and does not provide financial, legal, or tax advice through this report.
      </div>
    </div>
  );
};
